import { useAppInfo as useRealAppInfo } from '@kc/app-init-workflow/react';
import { Context } from './AppInfoContext';
import { useMockedAppInfo } from './mocks/use-app-info.mock';

export type AppInfo<T> = ReturnType<typeof useRealAppInfo> & { context: T };

export const useAppInfo: <T = Context>() => AppInfo<T> =
  process.env.REACT_APP_KEYCLOAK_MOCK === undefined ? useRealAppInfo : useMockedAppInfo;
